<template>
    <main id="main">
        <section class="login-section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8 col-xl-5">
                        <div class="min-height-100vh has-header d-flex align-items-center">
                            <div class="form-content form-team-content w-100 white-content">
                                <img src="https://www.compralaentrada.com/logos_cle/CLEORIGINAL.png" alt="Compralaentrad" class="w-100"/>
                                <div class="w-100 mt-3">
                                    <h2>¡Lamentamos las molestias!</h2>
                                    <p>Esta web se encuentra en mantenimiento.</p>
                                    <p>Pronto volverá a estar disponible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>    
</template>

<script>

    export default {
        head: {
            title: function() {
                return {
                    inner: 'Mantenimiento',
                    complement: 'Compralaentrada'
                }                         
            },
            meta: function() {
                return [
                    {name: 'application-name', content: 'Mantenimiento'},
                    {name: 'description', content: 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        }
    }
</script>

<style scoped>
    .min-height-100vh.has-header {
        min-height: calc(100vh - 91px);
    }
    .w-100 {
        width: 100%!important;
    }
</style>
